/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StatisticsTokenGraphData model module.
 * @module model/StatisticsTokenGraphData
 * @version 1.0
 */
class StatisticsTokenGraphData {
    /**
     * Constructs a new <code>StatisticsTokenGraphData</code>.
     * @alias module:model/StatisticsTokenGraphData
     */
    constructor() { 
        
        StatisticsTokenGraphData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StatisticsTokenGraphData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StatisticsTokenGraphData} obj Optional instance to populate.
     * @return {module:model/StatisticsTokenGraphData} The populated <code>StatisticsTokenGraphData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StatisticsTokenGraphData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('createdHvh')) {
                obj['createdHvh'] = ApiClient.convertToType(data['createdHvh'], 'Number');
            }
            if (data.hasOwnProperty('createdPer')) {
                obj['createdPer'] = ApiClient.convertToType(data['createdPer'], 'Number');
            }
            if (data.hasOwnProperty('createdXper')) {
                obj['createdXper'] = ApiClient.convertToType(data['createdXper'], 'Number');
            }
            if (data.hasOwnProperty('createdUsdt')) {
                obj['createdUsdt'] = ApiClient.convertToType(data['createdUsdt'], 'Number');
            }
            if (data.hasOwnProperty('createdArb')) {
                obj['createdArb'] = ApiClient.convertToType(data['createdArb'], 'Number');
            }
            if (data.hasOwnProperty('consumedHvh')) {
                obj['consumedHvh'] = ApiClient.convertToType(data['consumedHvh'], 'Number');
            }
            if (data.hasOwnProperty('consumedPer')) {
                obj['consumedPer'] = ApiClient.convertToType(data['consumedPer'], 'Number');
            }
            if (data.hasOwnProperty('consumedXper')) {
                obj['consumedXper'] = ApiClient.convertToType(data['consumedXper'], 'Number');
            }
            if (data.hasOwnProperty('consumedUsdt')) {
                obj['consumedUsdt'] = ApiClient.convertToType(data['consumedUsdt'], 'Number');
            }
            if (data.hasOwnProperty('consumedArb')) {
                obj['consumedArb'] = ApiClient.convertToType(data['consumedArb'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>StatisticsTokenGraphData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>StatisticsTokenGraphData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
StatisticsTokenGraphData.prototype['targetDate'] = undefined;

/**
 * @member {Number} createdHvh
 */
StatisticsTokenGraphData.prototype['createdHvh'] = undefined;

/**
 * @member {Number} createdPer
 */
StatisticsTokenGraphData.prototype['createdPer'] = undefined;

/**
 * @member {Number} createdXper
 */
StatisticsTokenGraphData.prototype['createdXper'] = undefined;

/**
 * @member {Number} createdUsdt
 */
StatisticsTokenGraphData.prototype['createdUsdt'] = undefined;

/**
 * @member {Number} createdArb
 */
StatisticsTokenGraphData.prototype['createdArb'] = undefined;

/**
 * @member {Number} consumedHvh
 */
StatisticsTokenGraphData.prototype['consumedHvh'] = undefined;

/**
 * @member {Number} consumedPer
 */
StatisticsTokenGraphData.prototype['consumedPer'] = undefined;

/**
 * @member {Number} consumedXper
 */
StatisticsTokenGraphData.prototype['consumedXper'] = undefined;

/**
 * @member {Number} consumedUsdt
 */
StatisticsTokenGraphData.prototype['consumedUsdt'] = undefined;

/**
 * @member {Number} consumedArb
 */
StatisticsTokenGraphData.prototype['consumedArb'] = undefined;






export default StatisticsTokenGraphData;

